<script lang="ts">
  /* eslint-disable @typescript-eslint/no-unused-vars */
  import Item from '../item.svelte'

  export let cells: any[];
</script>

<template lang="pug" src="./table.pug">

</template>
